<div class="app-shell">
  <app-splash [splash]="splash"></app-splash>

  @if (me && isFullApp && !me.must_change_password) {
    @if (!splash) {
      <div fxFlex="grow" fxLayout="row" class="mat-typography">
        <div [ngClass]="isCollapse ? 'collapse' : ''" class="ht-nav">
          <!--Menu sidebar mid-->
          <div class="ht-nav-sub">
            <div class="ht-nav-menu">
              <!--Collapse-->
              <div class="ht-nav-item">
                <div (click)="toogleCollapse()" class="ht-btn-collapse">
                  <i
                    [ngClass]="
                      isCollapse ? 'fa-chevrons-right' : 'fa-chevrons-left'
                    "
                    class="fa-solid"
                  ></i>
                  @if (!isCollapse) {
                    <span>Collapse</span>
                  }
                </div>
              </div>
              <!--Bot-->
              @if (me?.is_admin) {
                <div class="ht-nav-item">
                  <div
                    class="ht-nav-btn"
                    routerLinkActive="active"
                    routerLink="/automation/bots"
                  >
                    <i class="fa-solid fa-message-bot"></i>
                    <label>Automation</label>
                  </div>
                  <div class="ht-nav-list">
                    <a
                      routerLinkActive="active"
                      routerLink="/automation/bots/all"
                      >Bots</a
                    >
                    @if (hasAiKnowledgeAccess) {
                      <a
                        (click)="navigateToReactApp('automation/knowledgebase')"
                        routerLinkActive="active"
                      >
                        Knowledge base
                      </a>
                    }
                  </div>
                </div>
              }

              <!--QA Evaluator-->
              @if (hasQaEvaluatorAccess()) {
                <div class="ht-nav-item">
                  <div
                    class="ht-nav-btn"
                    routerLinkActive="active"
                    routerLink="/evaluator"
                  >
                    <i class="fa-solid fa-flask"></i>
                    <label>Evaluator</label>
                  </div>
                </div>
              }
              <!--Desk-->
              <div class="ht-nav-item">
                <div
                  class="ht-nav-btn"
                  routerLinkActive="active"
                  routerLink="/desk"
                >
                  <i class="fa-solid fa-headset"></i>
                  <label>Helpdesk</label>
                </div>
                <div class="ht-nav-list">
                  <a
                    routerLink="/desk/inbox"
                    [class.active]="isInboxLinkActive()"
                    >Inbox</a
                  >
                  <a routerLinkActive="active" routerLink="/desk/dashboard"
                    >Realtime Dashboard</a
                  >
                  @if ($hasCaseArchiveAccess | async) {
                    <a
                      [class.active]="isArchiveLinkActive()"
                      routerLink="/desk/archive"
                      >Case Archive</a
                    >
                  }
                  @if (hasWhatsappCallLogsAccess()) {
                    <a
                      routerLinkActive="active"
                      routerLink="/desk/whatsapp-call-logs"
                      >WhatsApp Call Logs</a
                    >
                  }
                </div>
              </div>
              <!--Contacts-->
              @if (hasContactsAccess()) {
                <div class="ht-nav-item">
                  @if (showContactsListLink()) {
                    <div
                      class="ht-nav-btn"
                      (click)="navigateToReactApp('contacts/list')"
                    >
                      <i class="fa-solid fa-address-book"></i>
                      <label>Contacts</label>
                    </div>
                  } @else {
                    <div
                      class="ht-nav-btn"
                      routerLink="/contacts/info-fields"
                      routerLinkActive="active"
                    >
                      <i class="fa-solid fa-address-book"></i>
                      <label>Contacts</label>
                    </div>
                  }
                  <div class="ht-nav-list">
                    @if (showContactsListLink()) {
                      <a (click)="navigateToReactApp('contacts/list')">List</a>
                    }
                    <a
                      routerLink="/contacts/info-fields"
                      routerLinkActive="active"
                      >Info Fields</a
                    >
                  </div>
                </div>
              }
              <!--Campaigns V2-->
              @if (hasCampaignsV2Access()) {
                <div class="ht-nav-item">
                  <div
                    class="ht-nav-btn"
                    (click)="navigateToReactApp('campaigns-v2/manage')"
                  >
                    <i class="fa-solid fa-flag"></i>
                    <label>Campaigns</label>
                  </div>
                  <div class="ht-nav-list">
                    <a (click)="navigateToReactApp('campaigns-v2/manage')"
                      >Campaigns</a
                    >
                  </div>
                </div>
              }
              <!--Campaigns-->
              @if (hasCampaignsAccess()) {
                <div class="ht-nav-item">
                  <div
                    class="ht-nav-btn"
                    routerLinkActive="active"
                    routerLink="/campaigns"
                  >
                    <i class="fa-solid fa-flag"></i>
                    <label>Campaigns</label>
                  </div>
                  <div class="ht-nav-list">
                    <a routerLink="/campaigns/manage" routerLinkActive="active"
                      >Campaigns List</a
                    >
                    <a
                      routerLink="/campaigns/contacts"
                      routerLinkActive="active"
                      >Contacts</a
                    >
                  </div>
                </div>
              }
              <!--Analytics-->
              @if (hasAnalyticsAccess()) {
                <div class="ht-nav-item">
                  <div
                    class="ht-nav-btn"
                    routerLinkActive="active"
                    routerLink="/analytics"
                  >
                    <i class="fa-solid fa-chart-simple"></i>
                    <label>Analytics</label>
                  </div>
                  <div class="ht-nav-list">
                    <a
                      routerLink="/analytics/overview"
                      routerLinkActive="active"
                      >Overview</a
                    >
                    @if (hasCopilotAccess()) {
                      <a
                        routerLink="/analytics/copilot"
                        routerLinkActive="active"
                        >AI Analytics</a
                      >
                    }
                    <a routerLink="/analytics/cases" routerLinkActive="active"
                      >Cases</a
                    >
                    <a routerLink="/analytics/agents" routerLinkActive="active"
                      >Agents</a
                    >
                    <a
                      routerLink="/analytics/automation"
                      routerLinkActive="active"
                      >Automation Metrics</a
                    >
                    @if (hasAnalyticsConversationsAccess()) {
                      <a
                        routerLink="/analytics/conversations"
                        routerLinkActive="active"
                        >Conversations</a
                      >
                    }
                  </div>
                </div>
              }

              <!--Organization-->
              @if (hasOrgSettingsAccess()) {
                <div class="ht-nav-item">
                  <div
                    class="ht-nav-btn"
                    routerLinkActive="active"
                    routerLink="/organization"
                  >
                    <i class="fa-solid fa-gear"></i>
                    <label>Organization Settings</label>
                  </div>
                  <div class="ht-nav-list">
                    <a
                      routerLink="/organization/general"
                      routerLinkActive="active"
                      >General</a
                    >
                    <a
                      routerLink="/organization/accounts"
                      routerLinkActive="active"
                      >Accounts</a
                    >
                    <a
                      routerLink="/organization/projects"
                      routerLinkActive="active"
                      >Projects</a
                    >
                    <a
                      routerLink="/organization/webhooks"
                      routerLinkActive="active"
                      >Webhooks</a
                    >
                    <a
                      routerLink="/organization/templates"
                      routerLinkActive="active"
                      >Templates</a
                    >
                  </div>
                </div>
              }
              @if (!me?.is_agent) {
                <div class="ht-nav-item">
                  <div
                    class="ht-nav-btn"
                    routerLinkActive="active"
                    routerLink="/addons"
                  >
                    <i class="fa-solid fa-puzzle-piece"></i>
                    <label>Add-ons</label>
                  </div>
                  <div class="ht-nav-list">
                    <a routerLink="/addons" routerLinkActive="active">
                      Add-ons
                    </a>
                  </div>
                </div>
              }
            </div>
            <!--Menu sidebar bottom-->
            <div class="ht-nav-bottom">
              <!--Help item-->
              <div class="ht-nav-item">
                <a
                  class="ht-nav-btn ht-nav-help"
                  href="https://help.hubtype.com/"
                  target="_blank"
                  routerLinkActive="active"
                >
                  <i class="fa-solid fa-circle-question"></i>
                  @if (!isCollapse) {
                    <span>Documentation</span>
                  }
                </a>
                <app-version [hidden]="isCollapse"></app-version>
              </div>
              <div class="hrline"></div>
              <div class="ht-nav-item ht-nav-item-profile">
                <div class="ht-nav-btn">
                  <app-avatar
                    routerLink="/profile"
                    [pic]="me?.pic"
                    [status]="me?.status"
                  >
                  </app-avatar>
                  <div class="ht-nav-username">
                    <div class="text-small no-wrap">{{ me?.name }}</div>
                    <div class="text-small-extra no-wrap"
                      >({{ me?.roleName }})</div
                    >
                  </div>
                  <div class="ht-nav-btn-arrows">
                    <i class="fa-solid fa-angle-up"></i>
                    <i class="fa-solid fa-angle-down"></i>
                  </div>
                </div>
                <div class="ht-nav-list ht-nav-list-pulltop">
                  <a routerLink="/profile" routerLinkActive="active">
                    {{ me?.name }}</a
                  >
                  <a (click)="toggleAway()">
                    {{
                      me?.status === 'status_away'
                        ? "Turn off 'Away' mode"
                        : "Turn on 'Away' mode"
                    }}
                    {{ me?.toggleStateName }}</a
                  >
                  <a (click)="logout()"> Logout</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div role="right-side" class="right-side" cdk-scrollable>
          <app-addons-announcement-banner />

          <ht-breadcrumb></ht-breadcrumb>
          <router-outlet></router-outlet>
          <pusher-status-handler></pusher-status-handler>
        </div>
      </div>
      <ht-whatsapp-calls />
    }
  } @else {
    <div role="right-side" class="right-side minimal-shell" cdk-scrollable>
      <router-outlet></router-outlet>
    </div>
  }
</div>
